import { render, staticRenderFns } from "./AssignableCrewCard.vue?vue&type=template&id=282ff27e&scoped=true"
import script from "./AssignableCrewCard.vue?vue&type=script&lang=js"
export * from "./AssignableCrewCard.vue?vue&type=script&lang=js"
import style0 from "./AssignableCrewCard.vue?vue&type=style&index=0&id=282ff27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ff27e",
  null
  
)

export default component.exports